import { useLocation, useNavigate } from 'react-router'
import { DefaultLoginRedirect, RedirectPathStateKey } from 'constants/General'

export const useAuthenticatedPathRedirect = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  const redirectToLanding = () => {
    const redirectPath = state?.[RedirectPathStateKey]
    void navigate(redirectPath ?? DefaultLoginRedirect)
  }

  const redirectWithState = (path: string) => {
    void navigate(path, { state })
  }

  return {
    redirectToLanding,
    redirectWithState,
  }
}
